import React from 'react';
import { cx } from 'emotion';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { css } from '@emotion/core';

const paginationWrapper = css`
  .Table__pageButton {
    font-size: 1.2rem;
    outline: none;
    border: none;
    background-color: transparent;
    cursor: pointer;
  }

  .Table__pageButton:disabled {
    cursor: not-allowed;
    color: gray;
  }

  .Table__pageButton--active {
    color: #45b3e3;
    font-weight: bold;
  }
`;

const filterPages = (visiblePages, totalPages) => {
  return visiblePages.filter(page => page <= totalPages);
};

const getVisiblePages = (page, total) => {
  if (total < 7) {
    return filterPages([1, 2, 3, 4, 5, 6], total);
  }
  if (page % 5 >= 0 && page > 4 && page + 2 < total) {
    return [1, page - 1, page, page + 1, total];
  }
  if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
    return [1, total - 3, total - 2, total - 1, total];
  }
  return [1, 2, 3, 4, 5, total];
};

const NewPagination = ({
  paginationClassName,
  canPreviousPage,
  canNextPage,
  pageIndex,
  pageOptions,
  onChangeInSelect,
  gotoPage,
  pageSize,
  showPageSizeOptions,
  setQuery,
}) => {
  const visiblePages = getVisiblePages(pageIndex, pageOptions.length);

  const changePageNumber = p => {
    gotoPage(p - 1);
    setQuery && setQuery({ page: p });
  };

  const changePageIndex = p => {
    gotoPage(p);
    setQuery && setQuery({ page: p + 1 });
  };
  return (
    <div className="pagination-bottom">
      <div
        css={paginationWrapper}
        className={cx(paginationClassName, '-pagination')}
      >
        <div className="-previous">
          <button
            type="button"
            className="-btn"
            style={{
              display: 'flex',
              flexFlow: 'row nowrap',
              alignItems: 'center',
            }}
            onClick={() => changePageIndex(pageIndex - 1)}
            disabled={!canPreviousPage}
          >
            <div style={{ margin: '0 auto' }}>Previous</div>
            <ArrowBackIcon />
          </button>
        </div>

        <div className="-center">
          <span className="-pageInfo">
            {visiblePages.map((p, index, array) => {
              return (
                <button
                  key={p}
                  className={
                    pageIndex + 1 === p
                      ? 'Table__pageButton Table__pageButton--active'
                      : 'Table__pageButton'
                  }
                  onClick={() => changePageNumber(p)}
                >
                  {array[index - 1] + 2 < p ? `...${p}` : p}
                </button>
              );
            })}
          </span>
        </div>

        <div className="-next">
          <button
            type="button"
            className="-btn"
            style={{
              display: 'flex',
              flexFlow: 'row nowrap',
              alignItems: 'center',
            }}
            // onClick={nextPage}
            onClick={() => changePageIndex(pageIndex + 1)}
            disabled={!canNextPage}
          >
            <ArrowForwardIcon />
            <div style={{ margin: '0 auto' }}>Next</div>
          </button>
        </div>
        {showPageSizeOptions && (
          <span className="select-wrap -pageSizeOptions">
            <select value={pageSize} onChange={onChangeInSelect}>
              {[5, 10, 20, 25, 50, 100].map(pSize => (
                <option key={pSize} value={pSize}>
                  {pSize} rows
                </option>
              ))}
            </select>
          </span>
        )}
      </div>
    </div>
  );
};

export default NewPagination;
